import { selectors } from '@sloyd/store-base';
import { call, delay, put, select } from 'saga-ts';
import { $a, invokeEvent } from 'shared-base';

export function* verifyPlayground() {
  try {
    const playground = yield* select(selectors.base.$playground);

    if (playground) {
      return;
    }

    const guid = 'play';

    yield put(
      $a('PROJECTS', 'create', guid, { name: 'playground', type: 'playground', emoji: '🎮' })
    );
  } catch (err) {
    invokeEvent('sentry', { err });
  }
}

export function* preparePlayground() {
  try {
    console.time('preparePlayground');
    yield* call(verifyPlayground);
    yield delay(50);
    const playground = yield* select(selectors.base.$playground);
    if (!playground) return;
    yield put($a('PLAYGROUND', 'zoom'));
    yield put($a('PROJECTS', 'clear', playground.id));
    console.timeEnd('preparePlayground');
  } catch (err) {
    invokeEvent('sentry', { err });
  }
}
